import React from 'react';
import type { AnalysisSuggestion } from '../types';
import { CheckCircleIcon } from './icons/CheckCircleIcon';
import { LightbulbIcon } from './icons/LightbulbIcon';
import { GlobeIcon } from './icons/GlobeIcon';

interface AnalysisSidebarProps {
  // 核心修改：允许 analysis 为 undefined 或 null，防止父组件传值延迟导致崩溃
  analysis?: AnalysisSuggestion[]; 
}

const getIconForType = (type: AnalysisSuggestion['type']) => {
  switch (type) {
    case 'ATS':
      return <CheckCircleIcon className="w-5 h-5 text-emerald-500" />;
    case 'Wording':
      return <LightbulbIcon className="w-5 h-5 text-amber-500" />;
    case 'Cultural':
      return <GlobeIcon className="w-5 h-5 text-sky-500" />;
    default:
      return <LightbulbIcon className="w-5 h-5 text-slate-500" />;
  }
};

const getTitleForType = (type: AnalysisSuggestion['type']) => {
    switch (type) {
        case 'ATS': return 'ATS Compatibility';
        case 'Wording': return 'Wording & Impact';
        case 'Cultural': return 'Cultural Adaptation';
        default: return 'General Suggestion';
    }
}

const AnalysisSidebar: React.FC<AnalysisSidebarProps> = ({ analysis }) => {
  return (
    <div className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm">
      <h3 className="text-xl font-bold text-slate-900 mb-4">Optimization Report</h3>
      
      {/* 核心修改点：
        1. 使用可选链 ?. 检查 analysis 是否存在。
        2. 如果 analysis 为 undefined，显示等待提示而非直接执行 .length。
      */}
      {!analysis ? (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500 mb-2"></div>
          <p className="text-sm text-slate-500">Refining your content for maximum professional impact. This usually takes a few seconds.</p>
        </div>
      ) : analysis.length === 0 ? (
        <p className="text-sm text-slate-500">No specific suggestions. Your resume looks great!</p>
      ) : (
        <div className="space-y-4">
          {analysis.map((item, index) => (
            <div key={index} className="flex gap-3">
              <div className="flex-shrink-0 mt-1">
                {/* 增加一层保护，防止 item 或 item.type 为空 */}
                {item?.type ? getIconForType(item.type) : <LightbulbIcon className="w-5 h-5 text-slate-300" />}
              </div>
              <div>
                <h4 className="font-semibold text-slate-800 text-sm">
                  {item?.type ? getTitleForType(item.type) : 'Suggestion'}
                </h4>
                <p className="text-sm text-slate-600">{item?.suggestion || 'No content provided.'}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AnalysisSidebar;
